<template>
  <div class="container">
    <!--Wrapper for login-->
    <div class="row" v-if="forgotPassword !== 3 && forgotPassword !== 5">
      <div class="col-6 left-block">
        <!--The whole text on the left side is an image-->
        <img
          class="product-details-image"
          src="../assets/icons/login/Product.svg"
        />
        <a href="https://www.agrometrics.com" class="website-url"
          >www.agrometrics.com</a
        >
      </div>

      <div class="col-6 right-block">
        <!--Form component on the right side-->
        <div class="login-wrapper">
          <h1 class="login-label" v-if="forgotPassword == 1">Login</h1>
          <h1 class="login-label" v-if="forgotPassword == 2">
            Forgot Password
          </h1>
          <h1 class="login-label" v-if="forgotPassword == 4">Reset Password</h1>
          <form
            class="login-form"
            v-if="forgotPassword == 1"
            v-on:submit="login"
          >
            <!--The small username text on the username input.
                            Look for styles starting with fade to change and use this as a guide
            https://vuejs.org/v2/guide/transitions.html-->
            <transition name="fade">
              <span class="user-label" v-if="userFocus">Username</span>
            </transition>
            <img class="user-icon" src="../assets/icons/login/User.svg" />
            <!--Change input type to email for final version-->
            <input
              type="text"
              class="input-field user"
              v-model="email"
              placeholder="username"
              @focus="changePlaceholder"
              @blur="changePlaceholder"
            />
            <!--The small passsword text on the password input-->
            <transition name="fade">
              <span class="password-label" v-if="passwordFocus">Password</span>
            </transition>
            <img
              class="password-icon"
              src="../assets/icons/login/Password.svg"
            />
            <input
              type="password"
              class="input-field passwd"
              ref="passwordfield"
              v-model="password"
              placeholder="password"
              @focus="changePlaceholder"
              @blur="changePlaceholder"
            />
            <!--The following element implements peek functionality for password filed-->
            <transition name="fade">
              <span
                class="peek-button"
                v-if="password != ''"
                @mouseup="showPassword"
                @mousedown="showPassword"
                >show</span
              >
            </transition>
            <span class="incorrect-label" v-if="loginError"
              >Username or Password is incorrect</span
            >
            <div class="forgot-label" @click="forgotPassword = 2">
              Forgot Password?
            </div>
            <button type="submit" class="login-button">LOGIN</button>
          </form>
          <form
            class="login-form"
            v-if="forgotPassword == 2"
            v-on:submit="handleForgotPassword"
          >
            <!--The small username text on the username input.
                            Look for styles starting with fade to change and use this as a guide
            https://vuejs.org/v2/guide/transitions.html-->
            <transition name="fade">
              <span
                class="user-label"
                v-if="forgotEmailFocus"
                :style="
                  forgotEmailError ? { color: '#DA0404' } : { color: '#24c756' }
                "
                >Email</span
              >
            </transition>
            <img class="user-icon" src="../assets/icons/login/User.svg" />
            <!--Change input type to email for final version-->
            <input
              type="text"
              class="input-field forgotemail"
              v-model="forgotEmail"
              placeholder="Email"
              @focus="changePlaceholder"
              @blur="changePlaceholder"
              :style="forgotEmailError ? { borderColor: '#DA0404' } : {}"
            />
            <span class="incorrect-label" v-if="forgotEmailError"
              >{{ this.forgotEmailMsg }}</span
            >
            <div class="forgot-label" @click="forgotPassword = 1">
              Login Here
            </div>
            <button type="submit" class="login-button">SEND CODE</button>
          </form>
          <form
            class="login-form"
            v-if="forgotPassword == 4"
            v-on:submit="handleResetPassword"
          >
            <!--The small username text on the username input.
                            Look for styles starting with fade to change and use this as a guide
            https://vuejs.org/v2/guide/transitions.html-->
            <transition name="fade">
              <span
                class="user-label"
                v-if="codeFocus"
                :style="codeError ? { color: '#DA0404' } : { color: '#24c756' }"
                >Code</span
              >
            </transition>
            <img class="user-icon" src="../assets/icons/login/code.svg" />
            <!--Change input type to email for final version-->
            <div @click="handleResendCode" class="resend-code-container">
              <span class="resend-code-text">Resend code</span>
            </div>
            <input
              type="text"
              class="input-field code"
              v-model="code"
              placeholder="code"
              @focus="changePlaceholder"
              @blur="changePlaceholder"
              :style="codeError ? { borderColor: '#DA0404' } : {}"
            />
            <span class="invalid-code-text" v-if="codeError">Invalid Code</span>
            <span class="resent-code-text" v-if="codeResent"
              >Code resent successfully</span
            >
            <!--The small passsword text on the password input-->
            <transition name="fade">
              <span
                class="new-password-label"
                v-if="newPasswordFocus"
                :style="
                  newPasswordError ? { color: '#DA0404' } : { color: '#24c756' }
                "
                >New Password</span
              >
            </transition>
            <img
              class="password-icon"
              src="../assets/icons/login/Password.svg"
            />
            <input
              type="password"
              class="input-field newpasswd"
              ref="newpasswordfield"
              v-model="newPassword"
              placeholder="New Password"
              @focus="changePlaceholder"
              @blur="changePlaceholder"
              :style="newPasswordError ? { borderColor: '#DA0404' } : {}"
            />
            <transition name="fade">
              <span
                class="peek-button"
                v-if="newPassword != ''"
                @mouseup="showNewPassword"
                @mousedown="showNewPassword"
                >show</span
              >
            </transition>
            <span class="new-password-error-text" v-if="newPasswordError"
              >New password does not meet requirements</span
            >
            
            <transition name="fade">
              <span class="confirm-password-label" v-if="confirmPasswordFocus"
                >Confirm Password</span
              >
            </transition>
            <img
              class="confirm-password-icon"
              src="../assets/icons/login/Password.svg"
            />
            <input
              type="text"
              class="input-field confirmpasswd"
              ref="confirmpasswordfield"
              v-model="confirmPassword"
              placeholder="Confirm Password"
              @focus="changePlaceholder"
              @blur="changePlaceholder"
            />
             <span class="confirm-password-error-text" v-if="confirmPasswordError"
              >Password not matching, Retry!!!</span
            >
            <!--The following element implements peek functionality for password filed-->
            <!-- <transition name="fade">
              <span
                class="peek-button"
                v-if="password != ''"
                @mouseup="showPassword"
                @mousedown="showPassword"
                >show</span
              >
            </transition> -->
            <!-- <span class="incorrect-label" v-if="loginError"
              >Username or Password is incorrect</span
            > -->
            <!-- <div class="forgot-label" @click="forgotPassword = 2">
              Forgot Password?
            </div> -->
            <button type="submit" class="login-button">UPDATE</button>
            <img
              class="password-info-icon"
              src="../assets/icons/login/passwordinfo.svg"
            />
          </form>
        </div>
        <!--Form component ends-->
      </div>
    </div>
    <!--Login page ends-->

    <!--Wrapper for forget password page-->
    <!-- <div class="row" v-if="forgotPassword==2">
      <div class="col-12 request">
        <h1 class="request-label">Request New Password</h1>
        <p class="request-sentence">Send E-mail Request for New Password</p>
        <button @click="forgotPassword=3" class="send-email">Send</button>
      </div>
    </div> -->
    <!--Forgot password ends-->
    <!--Succes Message-->
    <div class="row" v-if="forgotPassword == 3">
      <div class="col-12">
        <img class="sent-image" src="../assets/icons/login/Icon.svg" />
        <div class="response-sentence">
          <h2>6-Digit code sent out successfully to the email.</h2>
          Check your E-mail after sometime
        </div>
      </div>
      <button type="submit" class="col-4 send-code-button">OK</button>
    </div>
    <div class="row" v-if="forgotPassword == 5">
      <div class="col-12">
        <img class="sent-image" src="../assets/icons/login/Icon.svg" />
        <div class="response-sentence">
          <h2>Password has been successfully updated.</h2>
        </div>
      </div>
      <button type="submit" class="col-4 send-code-button">OK</button>
    </div>
    <!--Succes Message ends-->
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      passwordFocus: false,
      userFocus: false, //used for displaying the username suggestion
      loginError: false, //used for password suggestion
      forgotPassword: 1, //decides the vue to be displayed (login, forgot password, success),
      forgotEmail: "",
      code: "",
      newPassword: "",
      confirmPassword: "",
      forgotEmailFocus: false,
      newPasswordFocus: false,
      confirmPasswordFocus: false,
      codeFocus: false,
      forgotEmailError: false,
      forgotEmailMsg: '',
      codeError: false,
      newPasswordError: false,
      confirmPasswordError: false,
      codeResent: false,
    };
  },
  methods: {
    login: function (e) {
      //preventing default action so this function can be executed

      e.preventDefault();

      let username = this.email;
      let password = this.password;

      if (username != "" && password != "") {
        this.$store
          .dispatch("login", { username, password })
          .then(async () => {
            this.loginError = this.$store.state.loginError;
            if (!this.loginError) {
              var LogData = {
                user: this.$store.state.username,
                collection: "user",
                mode: "login",
                record: this.$store.state.username,
                fields: [],
                newValue: [],
                oldValue: [],
              };
              await this.$store.dispatch("AddUserLog", LogData);

              var trail = "inspectionTemplate";
              if (this.$store.state.user === "manager") {
                trail = "inspectionSummary";
              } else if (this.$store.state.user === "admin") {
                // trail = "admincenter/users";
                trail = "admincenter";
              }
              this.$router.push("/app/secure/" + trail);
              this.$store.dispatch("hideSnackBar");
            }
          })
          .catch((err) => (this.loginError = this.$store.state.loginError));
      } else {
        //if either of the fields are empty display 'incorrect username or password'

        if (username == "") {
          this.loginError = true;
        } else if (password == "") {
          this.loginError = true;
        }
      }
    },
    handleForgotPassword: function (e) {
      e.preventDefault();

      const email = this.forgotEmail;
      const REGEX_EMAIL = /^[a-z0-9]+[\._]?[a-z0-9]+[@]\w+[.]\w{2,3}$/;
      if(!REGEX_EMAIL.test(email)){
        this.forgotEmailError = true;
        this.forgotEmailMsg = 'Invalid Email'
        return;
      }
      this.$store
        .dispatch("validateEmail", { email })
        .then(async (res) => {
          this.forgotPassword = 3;
          setTimeout(() => {
            this.forgotPassword = 4;
          }, 1000);
        })
        .catch((err) => {
          this.forgotEmailError = true;
          this.forgotEmailMsg = 'Email is not registered'
        });
    },
    handleResetPassword: function (e) {
      e.preventDefault();
      const email = this.forgotEmail;
      const token = parseInt(this.code);
      const new_password = this.newPassword;
      if(this.newPasswordError || this.confirmPasswordError || this.newPassword === '' || this.code === '' || this.codeError){
        return;
      }
      this.$store.dispatch("resetPassword", {email, token, new_password})
        .then(async(res) => {
          console.log(res);
           this.forgotPassword = 5;
            setTimeout(() => {
              this.forgotPassword = 1;
            }, 1000);
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleResendCode: function (e) {
      console.log("resend code btn pressed");
      const email = this.forgotEmail
      this.$store
        .dispatch("validateEmail", { email })
        .then(async (res) => {
          this.codeResent = true;
          setTimeout(() => {
            this.codeResent = false;
          }, 2000)
        })
        .catch((err) => {
          this.forgotEmailError = true;
          this.forgotEmailMsg = 'Email is not registered'
        });
    },
    validateCode: function (e) {
      const code = this.code;
      const email = this.email;
      this.$store
        .dispatch("validateCode", { email: email, token: code })
        .then(async (res) => {
          if(res.data.error){
            this.codeError = true;
          }
          console.log("verify-otp", res);
        })
        .catch((err) => console.log(err));
    },
    changePlaceholder: function (e) {
      //retrieving the elemnt and it's class to check for the placeholder

      let elem = e.currentTarget;
      var elemclass = elem.getAttribute("class");

      /*
                placeholder isn't empty ---> element entering in focus
                ---> place empty string as placeholder & set the corresponding suggestion focus = true
            */

      if (elem.getAttribute("placeholder") != "") {
        elem.setAttribute("placeholder", "");
        // console.log(elemclass);
        if (elemclass == "input-field code") {
          this.codeFocus = true;
        } else if (elemclass == "input-field forgotemail") {
          this.forgotEmailFocus = true;
        } else if (elemclass == "input-field newpasswd") {
          this.newPasswordFocus = true;
        } else if (elemclass == "input-field confirmpasswd") {
          this.confirmPasswordFocus = true;
        } else if (elemclass == "input-field passwd") {
          this.passwordFocus = true;
        } else if (elemclass == "input-field user") {
          this.userFocus = true;
        }
      } else {
        /*
                placeholder is empty ---> element going out of focus
                ---> set corresponding string as placeholder & set the corresponding suggestion focus = false
            */
        if (elemclass == "input-field code") {
          this.codeFocus = false;
          elem.setAttribute("placeholder", "code");
          const code = this.code;
          const email = this.forgotEmail;
          this.$store
            .dispatch("validateCode", { email: email, token: parseInt(code) })
            .then(async (res) => {
              console.log("verify-otp", res);
              if(res.data.error){
                 this.codeError = true;
              }else{
                this.codeError = false
              }
            })
            .catch((err) => {
              this.codeError = true;
            });
        } else if (elemclass == "input-field forgotemail") {
          this.forgotEmailFocus = false;
          elem.setAttribute("placeholder", "email");
        } else if (elemclass == "input-field newpasswd") {
          this.newPasswordFocus = false;
          elem.setAttribute("placeholder", "new password");
          const re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
          const newPassword = this.newPassword;
          if(!re.test(newPassword)){
            this.newPasswordError = true;
          }else{
            this.newPasswordError = false;
          }
        } else if (elemclass == "input-field confirmpasswd") {
          this.confirmPasswordFocus = false;
          elem.setAttribute("placeholder", "confirm password");
          const newPassword = this.newPassword;
          const confirmPassword = this.confirmPassword;
          if(newPassword !== confirmPassword){
            this.confirmPasswordError = true;
          }else {
            this.confirmPasswordError = false;
          }
        } else if (elemclass == "input-field passwd") {
          this.passwordFocus = false;
          elem.setAttribute("placeholder", "password");
        } else if (elemclass == "input-field user") {
          this.userFocus = false;
          elem.setAttribute("placeholder", "username");
        }
      }

      //Clears error text when any input comes into focus

      this.loginError = false;
    },
    showPassword() {
      if (this.$refs.passwordfield.getAttribute("type") == "password") {
        this.$refs.passwordfield.setAttribute("type", "text");
      } else {
        this.$refs.passwordfield.setAttribute("type", "password");
      }
    },
    showNewPassword() {
      if (this.$refs.newpasswordfield.getAttribute("type") == "password") {
        this.$refs.newpasswordfield.setAttribute("type", "text");
      } else {
        this.$refs.newpasswordfield.setAttribute("type", "password");
      }
    },
  },
  mounted() {
    this.$store.commit("setOption", "Commodities");
  },
};
</script>

<style scoped>
/* Styles are organized from left to right and then parent to child elements */

/* Login view starts here (forgotPassword=1) */

.container {
  padding: 0px !important;
  width: 100vw !important;
  margin: 0px;
}

.row {
  width: 100vw;
}

.left-block,
.right-block {
  height: 100vh;
  background-color: #fff;
}

.left-block {
  padding: 5% 10% 40px 0px;
  background-image: url("../assets/icons/login/Left.svg");
  background-size: cover;
}

/* change this to affect details on the left side */
.product-details-image {
  float: right;
  display: block;
  height: 65%;
  width: 60%;
  margin-bottom: 40%;
  min-height: 50px;
  min-width: 25px;
  clear: right;
}

.website-url {
  position: absolute;
  bottom: 100px;
  right: 21%;
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 100;
  font-size: 18px;
  color: #fff;
  float: right;
  clear: right;
}

/* right-block styles*/

.right-block {
  vertical-align: middle;
  display: flex;
  overflow: auto;
  align-items: center;
}

.login-wrapper {
  /*keep position as relative or else its children will not use this as an anchor*/
  position: relative;
  margin: 0 auto;
  height: 50vh;
  width: 35rem;
}

.login-form {
  position: absolute;
  top: 22%;
  left: 5%;
  width: 90%;
  height: 70%;
}

.resend-code-container {
  width: 119px;
  height: 35px;
  background: #e7ffee;
  border-radius: 12px;
  position: absolute;
  top: 49px;
  left: 282px;
  cursor: pointer;
}

.resend-code-text {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #24c756;
  font-family: "Source Sans Pro", sans-serif;
  padding-left: 17px;
  position: absolute;
  bottom: 9px;
  left: 3px;
}

.login-label {
  position: absolute;
  top: 8%;
  left: 5%;
  margin-bottom: 10%;
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 50px;
  color: #29342e;
}

.input-field {
  width: 80%;
  float: right;
  margin-right: 30px;
  height: 55px;
  margin-top: 40px;
  padding-left: 20px;
  border: 1px solid #b4b4b4;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  line-height: 20px;
  font-size: 16px;
  display: block;
  background-color: white;
}

.input-field:focus {
  border-color: #24c756;
}

.user-label,
.password-label {
  position: absolute;
  padding: 0px 2px 0px 2px;
  background-color: white;
  color: #24c756;
  display: block;
  z-index: 1;
  left: calc(10% + 30px);
}

.new-password-label {
  position: absolute;
  padding: 0px 2px 0px 2px;
  background-color: white;
  color: #24c756;
  display: block;
  z-index: 1;
  left: calc(10% + 30px);
  top: 125px;
}

.confirm-password-label {
  position: absolute;
  padding: 0px 2px 0px 2px;
  background-color: white;
  color: #24c756;
  display: block;
  z-index: 1;
  left: calc(10% + 30px);
  top: 220px;
}

.peek-button {
  position: absolute;
  left: calc(75% + 30px);
  top: 155px;
  color: #24c756;
  cursor: pointer;
}

.password-label {
  top: 125px;
}

.user-label {
  top: 30px;
}

.user-icon,
.password-icon {
  position: absolute;
  right: calc(85% + 30px);
}

.user-icon {
  top: 60px;
}

.password-icon {
  top: 160px;
}
.confirm-password-icon {
  position: absolute;
  right: calc(85% + 30px);
  top: 247px;
}

.forgot-label {
  float: right;
  margin-top: 10px;
  margin-right: 30px;
  text-align: right;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #b4b4b4;
  cursor: pointer;
}

.incorrect-label {
  float: left;
  margin-left: calc(100% - 80% - 30px);
  width: 230px !important;
  text-align: left;
  width: 80%;
  margin-top: 10px;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #da0404;
}

.login-button {
  background-color: #24c756;
  border-radius: 4px;
  width: 80%;
  height: 55px;
  float: right;
  margin-right: 30px;
  margin-top: 40px;
  color: #fff;
}

.fade-enter-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.password-info-icon {
  position: absolute;
  right: calc(15% + 40px);
  top: 400px;
  padding-bottom: 50px;
}

/* media queries for centering login form for smaller screens */

@media only screen and (max-width: 600px) {
  .input-field,
  .login-button,
  .forgot-label,
  .incorrect-label {
    margin-right: 0px;
  }
  .login-label {
    left: 10%;
  }
  .user-icon,
  .password-icon {
    right: 85%;
  }
}

/* Login view ends here */

/* Send Email view starts here (forgotPassword=2) */

.send-email {
  position: fixed;
  top: 45%;
  left: 41%;
  background-color: #24c756;
  border-radius: 4px;
  width: 18%;
  height: 5%;

  color: #fff;
}

.request-label {
  position: fixed;
  top: 27%;
  left: 35%;
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 50px;

  color: #29342e;
}

.request-sentence {
  position: fixed;
  top: 40%;
  left: 40%;
  font-family: "Source Sans Pro", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;

  color: #29342e;
}

/* Send Email view ends here */

/* Success view starts here (forgotPassword=3) */

.response-sentence {
  margin-top: 30%;
  color: #24c756;
  text-align: center;
}

.sent-image {
  position: fixed;
  top: 35%;
  left: 45%;
}
.send-code-button {
  background-color: #24c756;
  border-radius: 4px;
  width: 80%;
  height: 55px;
  margin-right: 30px;
  margin-top: 40px;
  color: #fff;
  position: fixed;
  top: 70%;
  left: 33%;
}

.invalid-code-text {
  position: absolute;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #da0404;
  top: 98px;
  left: 66px;
}

.resent-code-text {
  position: absolute;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #24c756;
  top: 98px;
  left: 66px;
}

.new-password-error-text {
  position: absolute;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #da0404;
  top: 194px;
  left: 66px;
}
.confirm-password-error-text{
  position: absolute;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #da0404;
  top: 294px;
  left: 66px;
}
</style>
